import React, { useState } from "react";
import { Switch, Route } from "react-router-dom";

import Course from "./components/Course/Course";
import MainLayout from "./components/Layouts/MainLayout";
import Login from "./components/Login/Login";
import Register from "./components/Register/Register";
import Archive from "./components/Course/Archive";
import SingleCourse from "./components/Course/SingleCourse";
import { useSelector } from "react-redux";
import { paginate } from "./utils/paginate";


import Logout from "./components/Login/Logout";

import { AutProvider } from "./contexts/AuthProvider";
import { supabase } from "./utils/supabaseClient";
import UserProfile from "./components/profile/UserProfile";
import Article from "./components/Course/Article";
import PrivateLayout from "./components/Layouts/PrivateLayout";
import Dashboard from "./components/admin/Dashboard";

import CourseTable from "./components/admin/CourseTable";
import AdminContext from "./contexts/AdminContext";
import Favorite from "./components/favorite/Favorite";
import ScrollToTop from "./components/Layouts/ScrollToTop"
const Toplearn = props => {

    const [dataPost, setDataPost] = useState([]);

    const post = async () => {
        let { data, error } = await supabase
            .from('post')
            .select('*');
        setDataPost(data)
    }




    const courses = useSelector(state => state.courses);
    const user = useSelector((state) => state.user);
    const indexCourses = paginate(courses, 1, 8);




    return (
        <Switch>
            <Route path={["/dashboard"]}>
                <PrivateLayout>
                    <Route path="/dashboard/courses" >
                        <AdminContext courses={courses}>
                            <CourseTable />
                        </AdminContext>
                    </Route>
                    <Route path="/dashboard" exact >
                        <Dashboard courses={courses} />
                    </Route>
                </PrivateLayout>
            </Route>
            <Route path={["/"]} >
                <MainLayout>
                    <AutProvider>

                        <Switch>
                            <Route path="/login">
                                <Login />


                            </Route>

                            <Route path="/logout">

                                <Logout />

                            </Route>

                            <Route path="/favorite">

                                <Favorite />

                            </Route>


                            <Route path="/register">
                                <Register />
                            </Route>

                            <Route path="/archive">
                                <ScrollToTop>
                                    <Archive />
                                </ScrollToTop>
                            </Route>

                            <Route path="/course/:id">
                                <SingleCourse />
                            </Route>
                            <Route path="/article/:idarticle">
                                <Article />
                            </Route>

                            <Route path="/" exact>
                                <Course courses={indexCourses} />
                            </Route>



                        </Switch>
                    </AutProvider>
                </MainLayout>
            </Route>
        </Switch>
    );
};

export default Toplearn;
